import { loadRuntimeConfig } from '@/env';

/**
 * Load the runtime configuration before anything that reads it is evaluated.
 *
 * The dynamic import is the point: `src/api/client.ts` calls `axios.create({ baseURL })` at
 * module scope, so importing the app statically would capture the build-time default before
 * `/config.json` had been fetched. Deferring the import means the whole module graph evaluates
 * against real configuration.
 */
async function start() {
  await loadRuntimeConfig();
  const { mount } = await import('@/bootstrap');
  mount();
}

void start();
